import Vue from 'vue';
import Vuex from "vuex";

Vue.use(Vuex);

import state from "./state";
// import * as getters from './getters';
import * as mutations from "./mutations";
import * as actions from "./actions";

// import product from "./modules/product";
// import cart from "./modules/cart";

import auth from "./modules/auth/index"
import akun from "./modules/akun/index"
import sekolah from "./modules/sekolah/index"
import guru from "./modules/guru/index"
import tendik from "./modules/tendik/index"
import master from "./modules/master/index"
import roti from "./modules/roti/index"
import rosek from "./modules/rosek/index"
import info from "./modules/info/index"
import dinas from "./modules/dinas/index"
import kapendik from "./modules/kapendik/index"
import timer from "./modules/timer/index"
import config from "./modules/config/index"

export default new Vuex.Store({
    state,
    // getters,
    mutations,
    actions,

    modules: {
        auth,
        akun,
        sekolah,
        guru,
        tendik,
        master,
        roti,
        rosek,
        kapendik,
        timer,
        info,
        dinas,
        config
    }
});